import React from 'react';
import { Container, Box } from '@mui/material';
import PlayerStatsTable from '../components/PlayerStatsTable';
import { API_ENDPOINTS } from '../config/api';

const CareerGeneralStatsPage = () => {
  return (
    <Container maxWidth="xl">
      <Box sx={{ my: 4 }}>
        <PlayerStatsTable apiUrl={API_ENDPOINTS.PLAYER_STATS} careerStats={true} />
      </Box>
    </Container>
  );
};

export default CareerGeneralStatsPage; 